import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { getUserInfo } from '@utils/Util';

import CommonImage from '@/components/CommonImage';

const RequestDropdown = () => {
	const [isRequestDropdownOpen, setIsRequestDropdownOpen] = useState(false);
	const [openRequestItem, setOpenRequestItem] = useState(null);
	const requestDropdownRef = useRef(null);

	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (!requestDropdownRef.current?.contains(event.target)) {
				setIsRequestDropdownOpen(false);
				setOpenRequestItem(null);
			}
		};

		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, []);

	const handleRequestDropdownToggle = () => {
		setIsRequestDropdownOpen((prev) => {
			const nextState = !prev;
			if (!nextState) {
				setOpenRequestItem(null);
			}

			return nextState;
		});
	};

	const handleRequestItemToggle = (itemKey) => {
		setOpenRequestItem((prev) => (prev === itemKey ? null : itemKey));
	};

	const handleRequestNavigate = (event, url) => {
		event.preventDefault();
		event.stopPropagation();
		window.location.assign(url);
	};

	const getMaterialRequestLink = (subType) =>
		`/app/request/request/new?category=material_requisition&subType=${subType}`;

	const getDesignRequestLink = (subType) =>
		`/app/request/request/new?category=design_request&subType=${subType}`;

	const primaryUserType = getUserInfo()?.primaryUserType;
	const hasPrimaryAccess = (allowedUserTypes = []) => allowedUserTypes.includes(primaryUserType);

	const materialRequisitionPermission = () => {
		return hasPrimaryAccess([
			'FASHION_DESIGNER',
			'GRAPHICS_DESIGNER',
			'PRODUCT_DEVELOPMENT',
			'ACCOUNT_MANAGER',
			'BUSINESS_DEVELOPMENT_MANAGER',
			'SAMPLE_SECTION_LEAD',
			'PROJECT_MANAGER',
			'MERCHANDISER',
			'ADMIN'
		]);
	};

	const nitexRequestPermission = () => {
		return hasPrimaryAccess([
			'FASHION_DESIGNER',
			'ACCOUNT_MANAGER',
			'BUSINESS_DEVELOPMENT_MANAGER',
			'ADMIN'
		]);
	};

	const buyerRequestPermission = () => {
		return hasPrimaryAccess([
			'FASHION_DESIGNER',
			'ACCOUNT_MANAGER',
			'BUSINESS_DEVELOPMENT_MANAGER',
			'PROJECT_MANAGER',
			'ADMIN'
		]);
	};
	const techpackRequestPermission = () => {
		return hasPrimaryAccess([
			'FASHION_DESIGNER',
			'ACCOUNT_MANAGER',
			'PROJECT_MANAGER',
			'MERCHANDISER',
			'GRAPHICS_DESIGNER',
			'ADMIN'
		]);
	};

	return (
		<div
			className={`request-dropdown ${isRequestDropdownOpen ? 'is-open' : ''}`}
			ref={requestDropdownRef}
		>
			<button
				type="button"
				className="request-dropdown-trigger d-flex align-items-center button primary size32"
				onClick={handleRequestDropdownToggle}
			>
				<span className="request-dropdown-trigger-text">Send Request</span>
				<span className="request-dropdown-trigger-caret ml-1">
					<CommonImage
						src="/icons/down-arrow-white.svg"
						width={14}
						height={14}
						alt="open request menu"
					/>
				</span>
			</button>

			<div className="request-dropdown-menu-wrap">
				<ul className="request-dropdown-menu shadow-2dp">
					<li
						className={`request-dropdown-item request-dropdown-item-with-children ${openRequestItem === 'material-requisition' ? 'is-open' : ''} ${materialRequisitionPermission() ? '' : 'd-none'}`}
						onClick={() => handleRequestItemToggle('material-requisition')}
					>
						<span className="request-dropdown-item-arrow">&#8249;</span>
						<span className="request-dropdown-item-label">Material Requisition</span>
						<div className="request-dropdown-child-menu shadow-2dp">
							<ul>
								<li>
									<Link
										className="request-dropdown-child-item"
										to={getMaterialRequestLink('fabric')}
										onClick={(event) =>
											handleRequestNavigate(event, getMaterialRequestLink('fabric'))
										}
									>
										Fabric
									</Link>
								</li>
								<li>
									<Link
										className="request-dropdown-child-item"
										to={getMaterialRequestLink('trims')}
										onClick={(event) =>
											handleRequestNavigate(event, getMaterialRequestLink('trims'))
										}
									>
										Trims
									</Link>
								</li>
								<li>
									<Link
										className="request-dropdown-child-item"
										to={getMaterialRequestLink('print_development')}
										onClick={(event) =>
											handleRequestNavigate(
												event,
												getMaterialRequestLink('print_development')
											)
										}
									>
										Print technique Dev
									</Link>
								</li>
								<li>
									<Link
										className="request-dropdown-child-item"
										to={getMaterialRequestLink('embroidery_development')}
										onClick={(event) =>
											handleRequestNavigate(
												event,
												getMaterialRequestLink('embroidery_development')
											)
										}
									>
										Embroidery Dev
									</Link>
								</li>
								<li>
									<Link
										className="request-dropdown-child-item"
										to={getMaterialRequestLink('wash_range_development')}
										onClick={(event) =>
											handleRequestNavigate(
												event,
												getMaterialRequestLink('wash_range_development')
											)
										}
									>
										Wash Range Dev
									</Link>
								</li>
							</ul>
						</div>
					</li>
					<li
						className={`request-dropdown-item request-dropdown-item-with-children ${openRequestItem === 'design-request' ? 'is-open' : ''}`}
						onClick={() => handleRequestItemToggle('design-request')}
					>
						<span className="request-dropdown-item-arrow">&#8249;</span>
						<span className="request-dropdown-item-label">Design Request</span>

						<div className="request-dropdown-child-menu shadow-2dp">
							<ul>
								{nitexRequestPermission() && (
									<li>
										<Link
											className="request-dropdown-child-item"
											to={getDesignRequestLink('nitex_development')}
											onClick={(event) =>
												handleRequestNavigate(
													event,
													getDesignRequestLink('nitex_development')
												)
											}
										>
											Nitex Dev.
										</Link>
									</li>
								)}
								{buyerRequestPermission() && (
									<li>
										<Link
											className="request-dropdown-child-item"
											to={getDesignRequestLink('buyer_development')}
											onClick={(event) =>
												handleRequestNavigate(
													event,
													getDesignRequestLink('buyer_development')
												)
											}
										>
											Buyer Dev.
										</Link>
									</li>
								)}
								{buyerRequestPermission() && (
									<li>
										<Link
											className="request-dropdown-child-item"
											to={getDesignRequestLink('graphics_development')}
											onClick={(event) =>
												handleRequestNavigate(
													event,
													getDesignRequestLink('graphics_development')
												)
											}
										>
											Artwork Dev.
										</Link>
									</li>
								)}
								{techpackRequestPermission() && (
									<li>
										<Link
											className="request-dropdown-child-item"
											to={getDesignRequestLink('techpack_update_request')}
											onClick={(event) =>
												handleRequestNavigate(
													event,
													getDesignRequestLink('techpack_update_request')
												)
											}
										>
											Techpack update request
										</Link>
									</li>
								)}
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default RequestDropdown;
